import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static values = {
        first: String,
        second: String,
    };

    static targets = [
        'container',
        'toggleButton',
    ];

    toggleMobileContainer(event) {
        event.preventDefault();

        if ($(this.containerTarget).hasClass('d-none')) {
            $(this.containerTarget).removeClass('d-none');
            $(this.toggleButtonTarget).addClass('rotate-arrow');
        } else {
            $(this.containerTarget).addClass('d-none');
            $(this.toggleButtonTarget).removeClass('rotate-arrow');
        }
    }

    toggleInner(event) {
        event.preventDefault();
        const toggleElement = event.currentTarget;
        const innerUl = toggleElement.nextElementSibling;

        if (innerUl && innerUl.classList.contains('inner-ul')) {
            innerUl.classList.toggle('show');
            toggleElement.classList.toggle('open');
        }
    }
}
